export default __webpack_public_path__ + "static/media/jesus.8d936468.jpeg";